module.exports = __webpack_public_path__ + "static/media/points6_3.3e8e7c00.png";